/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Cache from 'fierry/flux/cache';

import HexGeometry from 'galax/client/geometry/hex';
import ZoneGeometry from 'galax/client/geometry/zone';


export default class
{
  constructor (zoom)
  {
    this.hex = new HexGeometry(zoom);

    this.zoneCache = new Cache(location => new ZoneGeometry(location, this));
  }


  getHex ()
  {
    return this.hex;
  }


  getZone (location)
  {
    return this.zoneCache.get(location);
  }


};
